import { memo } from 'react'

import { Heading } from '../Heading'
import { TwinSpinner } from '../TwinSpinner'

interface GeneratingStateProps {
  profilePictureUrl?: string
}

const GeneratingState: React.FC<GeneratingStateProps> = memo(
  ({ profilePictureUrl }) => {
    return (
      <div className="w-full aspect-video overflow-hidden relative rounded-2x max-w-[750px] mb-auto sm:mb-0">
        {profilePictureUrl && (
          <>
            <div
              className="absolute inset-0 bg-cover bg-center bg-no-repeat rounded-2xl"
              style={{
                backgroundImage: `url(${profilePictureUrl})`,
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80 backdrop-blur-sm rounded-2xl" />
          </>
        )}

        <div className="relative z-10 h-full flex flex-col items-center justify-center px-0 sm:px-4 pt-4 sm:pt-10 rounded-2xl">
          <Heading
            title="Generating Your Twin"
            subtitle="Feel free to close this window. You can always return and check back the progress."
          />
          <div className="shrink-0 h-12 w-12 rounded-full bg-dark-neutral-500 text-white flex items-center justify-center mb-8">
            <TwinSpinner />
          </div>
        </div>
      </div>
    )
  },
)

export { GeneratingState }
